module.exports = __webpack_public_path__ + "static/media/icon-subir.82dcbfc2.svg";